import clsx from "clsx";
import { Button, Icon } from "@/shared/ui";
import { Tab } from "@/domains/business/constants/tab";

type Props = {
  tab: Tab;
  active: boolean;
  text: string;
  iconCategory: string;
  iconName: string;
  onClick: (tab) => void;
};

export default function DeviceTabButton({
  tab,
  active,
  text,
  iconCategory,
  iconName,
  onClick,
}: Props) {
  return (
    <Button
      variant="solid"
      className={clsx(
        "h-[2.75rem] px-3.5 flex justify-start items-center gap-2.5 hover:brightness-110",
        active ? "bg-white text-[#007DD8]" : "bg-[#00518B]",
      )}
      onClick={() => onClick(tab)}
    >
      <Icon category={iconCategory} name={iconName} className="w-4" />
      {text}
    </Button>
  );
}
